import React from "react";

import { useTranslation } from "react-i18next";

import { getPaths } from "core/getPaths";
import { Button } from "shared/uikit";

import LeagueTransactionsHistory from "../../Components/TransactionsHistory";

const { league: leagueRoutes } = getPaths();

interface PaymentsFullTransactionHistoryProps {
	id: string;
}

const PaymentsFullTransactionHistory: React.FC<PaymentsFullTransactionHistoryProps> = ({ id }) => {
	const { t } = useTranslation();

	return (
		<>
			<Button link={`${leagueRoutes.getPath()}/${id}/payments`} className="mb-4">
				{t("back")}
			</Button>
			<LeagueTransactionsHistory leagueId={id} asPage />
		</>
	);
};

export default PaymentsFullTransactionHistory;
